import {
  CreateLocationPayload,
  CreateUpdateLocationResponse,
} from '@hakimo-ui/hakimo/types';
import { useAuthenticatedMutation } from '../shared/useAuthenticatedMutation';

export function useCreateLocation(
  tenantId: string,
  onSuccess?: (data: CreateUpdateLocationResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}/locations`;
  const request = new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    CreateUpdateLocationResponse,
    CreateLocationPayload
  >(request, {
    onSuccessInvalidationKeys: [
      ['admin-tenants'],
      ['admin-tenant-details', tenantId],
    ],
    onSuccess,
    onError,
  });
}

export default useCreateLocation;
